import TurnusStore from 'src/stores/TurnusStore';
import KlientStore from 'src/stores/KlientStore';
import DenStore from 'src/stores/DenStore';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import {
    Grid,
    Drawer,
    AppBar,
    Toolbar,
    IconButton,
    FormControl,
    InputLabel,
    Table,
    Select,
    MenuItem,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Typography,
    TextField,
    Paper,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Fab,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Tooltip,
    Checkbox,
    FormControlLabel,
    withStyles,
    createStyles,
    RadioGroup,
    Radio,
    ExpansionPanel,
    ExpansionPanelSummary,
    ExpansionPanelDetails,
    Switch,
    LinearProgress
} from '@material-ui/core';
import Klient from 'src/models/Klient';
import { computed, observable, action } from 'mobx';
import NavigationDrawerItems from './NavigationDrawerItems';
import MenuIcon from '@material-ui/icons/Menu';
import { inject, observer } from 'mobx-react';
import 'src/assets/styles/index.css'
import Turnus from 'src/models/Turnus';
import DoneIcon from '@material-ui/icons/Done';
import DeleteIcon from '@material-ui/icons/Delete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AddIcon from '@material-ui/icons/Add';
import SaveIcon from '@material-ui/icons/Save';
import DateRangeIcon from '@material-ui/icons/DateRange';
import {MuiPickersUtilsProvider, DatePicker, Calendar} from "material-ui-pickers"
import MomentUtils from '@date-io/moment';
import 'moment/locale/cs';
import {ClientTurnusesSection} from 'src/components/ClientTurnusesSection';
import ClientSelectionDialog from './ClientSelectionDialog';
import TurnusNewDialog from './TurnusNewDialog';
import ObjednavkaStore from 'src/stores/ObjednavkaStore';
import NewOrderResponse from 'src/services/response/NewOrderResponse';
import Objednavka from 'src/models/Objednavka';
import Den from 'src/models/Den';
import Sleva from 'src/models/Sleva';
import DayNewDialog from './DayNewDialog';
import CalculateOrderResponse from 'src/services/response/CalculateOrderResponse';
import CiselnikyStore from 'src/stores/CiselnikyStore';
import AuthStore from 'src/stores/AuthStore';
import NovaObjednavka from 'src/models/NovaObjednavka';
import { isUndefined } from 'util';
import TurnusEditDialog from './TurnusEditDialog';
import moment from 'moment';
import { Program } from 'src/classes/Program';
import WebObjednavka from 'src/models/WebObjednavka';
import LoggingBase from "../logging/LoggingBase";

const styles = createStyles(theme => ({
    dayWrapper: {
        position: "relative",
    },
    day: {
        width: 36,
        height: 36,
        fontSize: theme.typography.caption.fontSize,
        margin: "0 2px",
        color: "inherit",
    },
    customDayHighlight: {
        position: "absolute",
        top: 0,
        bottom: 0,
        left: "2px",
        right: "2px",
        border: `1px solid ${theme.palette.secondary.main}`,
        borderRadius: "50%",
    },
    nonCurrentMonthDay: {
        color: theme.palette.text.disabled,
    },
    highlightNonCurrentMonthDay: {
        color: "#676767",
    },
    highlight: {
        background: "#830daa",
        color: theme.palette.common.white,
    },
    highlightNahrada: {
        background: "#d61bba",
        color: theme.palette.common.white,
    },
    highlightZmena: {
        background: "#1bd653",
        color: theme.palette.common.white,
    },
    fullHighlight: {
        extend: "highlight",
        borderTopLeftRadius: "50%",
        borderBottomLeftRadius: "50%",
        borderTopRightRadius: "50%",
        borderBottomRightRadius: "50%",
    },
    firstHighlight: {
        extend: "highlight",
        borderTopLeftRadius: "50%",
        borderBottomLeftRadius: "50%",
    },
    endHighlight: {
        extend: "highlight",
        borderTopRightRadius: "50%",
        borderBottomRightRadius: "50%",
    },
}));

export interface IOrderNewProps extends RouteComponentProps<any> {
    klientStore?: KlientStore;
    turnusStore?: TurnusStore;
    objednavkaStore?: ObjednavkaStore;
    denStore?: DenStore;
    ciselnikyStore?: CiselnikyStore;
    authStore?: AuthStore;
    klientId?: number;
    orderTemplate?: NovaObjednavka;
    loggingBase?: LoggingBase;
    classes;
}

@inject('klientStore')
@inject('turnusStore')
@inject('objednavkaStore')
@inject('denStore')
@inject('ciselnikyStore')
@inject('authStore')
@inject('loggingBase')
@observer
class OrderNew extends React.Component<IOrderNewProps>{

    constructor(props: Readonly<IOrderNewProps>) {
        super(props);
        console.log("LOAD: OrderNew");
        if(!isUndefined(this.props.klientId)) {
            console.log("OrderNew: " + this.props.klientId);
            const kl = this.props.klientStore.getClientById(this.props.klientId);
            this.clientSelected(kl)();
        } else if(!isUndefined(this.props.orderTemplate)) {
            this.klienti = this.props.orderTemplate.klienti;
            this.turnusy = this.props.orderTemplate.turnusy;
            this.dny = this.props.orderTemplate.dny;
            this.slevy = this.props.orderTemplate.slevy;
            this.slevy.forEach((val, key) => {
                console.log("sleva: " + val + " - " + key);
                if(val !== '-') {
                    this.slevySet.set(key, true);
                }
            })
            this.nekompletni = this.props.orderTemplate.nekompletni;
            this.eko = this.props.orderTemplate.eko;
            this.castecneMenu = this.props.orderTemplate.castecneMenu;
            if(this.props.orderTemplate.webObjednavka !== 0 && this.props.orderTemplate.webObjednavka !== null) {
                this.webObjednavka = this.props.objednavkaStore.getWebObjednavkaByID(this.props.orderTemplate.webObjednavka);
                console.log("OrderNew: web order: " + this.props.orderTemplate.webObjednavka);
            }
            if(this.klienti !== null && this.klienti !== undefined) {
                this.klienti.forEach(kl => {
                    console.log("OrderNew: client from template: " + kl.id)
                })
            }
            this.calculateOrder();
        }
    }

    // GUI
    
    @observable private isDeleteDialogOpened: boolean = false;
    @observable private isClientSelectDialogOpen: boolean = false;
    @observable private isNewTurnusDialogOpen: boolean = false;
    @observable private isEditTurnusDialogOpen: boolean = false;
    @observable private isProgressBarOpened: boolean = false;

    private toDelete: string = '';
    private turnusToDelete: Turnus = null;
    private denToDelete: Den = null;

    @observable private turnusToEdit: Turnus = null;

    private log = (message: string) => {
        this.props.loggingBase.logMessage(message, true);
    }

    @action
    private handleChange = name => event => {
        this[name] = event.target.value;
    };

    @action
    private handleCheckedChange = (name, checked, unchecked) => event => {
        this[name] = event.target.checked ? checked : unchecked;
    };
    
    @action
    private handleDialClose = name=> event => {
        this[name] = !this[name];
    }

    private handleDeleteDialogOK = event => {
        this.isDeleteDialogOpened = false;
        if(this.toDelete === 'turnus') {
            const index = this.turnusy.get(this.turnusToDelete.idKlient).findIndex(a => a === this.turnusToDelete);
            this.turnusy.get(this.turnusToDelete.idKlient).splice(index, 1);
            this.calculateOrder();
        } else if(this.toDelete === 'den') {
            const index = this.dny.get(this.denToDelete.idKlient).findIndex(a => a === this.denToDelete);
            this.dny.get(this.denToDelete.idKlient).splice(index, 1);
        }
    }

    // Other stuff

    @observable private isDrawerOpened: boolean = false;

    @action
    private drawerMenuClick = event => {
        this.isDrawerOpened = !this.isDrawerOpened;
    }

    @action
    private handleTurnusRowClick = turnus => evt => {
        if(evt.nativeEvent.toElement.nodeName === "TD") {
            this.turnusToEdit = turnus;
            this.isEditTurnusDialogOpen = true;
        }
    }

    // nova objednavka

    private klienti: Klient[] = [];
    private turnusy: Map<number, Turnus[]> = new Map();
    @observable private dny: Map<number, Den[]> = new Map();
    @observable private slevy: Map<number, string> = new Map();
    private slevySet: Map<number, boolean> = new Map();
    @observable private eko: Map<number, boolean> = new Map();
    private ekoSet: Map<number, boolean> = new Map();
    @observable private nekompletni: Map<number, boolean> = new Map();
    @observable private castecneMenu: Map<number, boolean> = new Map();
    private castecneMenuSet: Map<number, boolean> = new Map();
    private newTurnusKlientId: number = 0;
    private newDenKlientId: number = 0;
    @observable private webObjednavka: WebObjednavka = null;

    @action
    private addTurnus = (client: Klient) => event => {
        this.newTurnusKlientId = client.id;
        this.isNewTurnusDialogOpen = true;
    }

    @action
    private addClient = () => {
        this.isClientSelectDialogOpen = true;
    }

    private clientSelected = (client: Klient) => () => {
        this.isClientSelectDialogOpen = false;
        this.turnusy.set(client.id, []);
        this.dny.set(client.id, []);
        this.slevy.set(client.id, '-');
        this.eko.set(client.id, false);
        this.nekompletni.set(client.id, false);
        this.castecneMenu.set(client.id, false);
        this.klienti.push(client);
    }

    private turnusAdded = (turnus: Turnus) => {
        this.isNewTurnusDialogOpen = false;
        turnus.idKlient = this.newTurnusKlientId;
        this.turnusy.get(turnus.idKlient).push(turnus);
        this.calculateOrder();
    }

    @action
    private turnusChanged = (newTurnus: Turnus, oldTurnus: Turnus) => {
        this.isEditTurnusDialogOpen = false;
        console.log('old program: ' + oldTurnus.program);
        console.log('updated program: ' + newTurnus.program);
        this.turnusToEdit.loadFromEntity(newTurnus);
        this.calculateOrder();
    }

    private handleTurnusDeleteClick = (turnus: Turnus) => event => {
        this.toDelete = 'turnus';
        this.turnusToDelete = turnus;
        this.isDeleteDialogOpened = true;
    }

    private handleDenDeleteClick = (den: Den) => event => {
        this.toDelete = 'den';
        this.denToDelete = den;
        this.isDeleteDialogOpened = true;
    }

    private calculateOrder = () => {
        this.props.objednavkaStore.calculateNewOrder(this.turnusy, this.dny)
            .then((retVal: CalculateOrderResponse[]) => {
                retVal.forEach(response => {
                    const slevaSet:boolean = this.slevySet.has(response.clientId);
                    console.log("sleva set: " + slevaSet);
                    if(!slevaSet) {
                        if(response.discount != null) {
                            console.log("discount:" + response.discount.id);
                            this.slevy.set(response.clientId, response.discount.id);
                        } else {
                            this.slevy.set(response.clientId, '-');
                        }
                    }

                    const menuSet: boolean = this.castecneMenuSet.has(response.clientId);
                    if(!menuSet && response.partialMenu === true) {
                        this.castecneMenu.set(response.clientId, true);
                    } else if(!menuSet && response.partialMenu === false) {
                        this.castecneMenu.set(response.clientId, false);
                    }
                });

            });
    }

    private previewOrder = () => () => {
        const newObj = new NovaObjednavka();
        newObj.klienti = this.klienti;
        newObj.turnusy = this.turnusy;
        newObj.dny = this.dny;
        newObj.slevy = this.slevy;
        newObj.eko = this.eko;
        newObj.nekompletni = this.nekompletni;
        newObj.castecneMenu = this.castecneMenu;
        newObj.webObjednavka = this.webObjednavka == null ? null : this.webObjednavka.id;
        this.props.objednavkaStore.orderTemplate = newObj;
        this.props.history.push(`/neworderPreview`)
    }

    private createOrder = (whereTo: string) => () => {
        console.log("createOrder: start");
        this.isProgressBarOpened = true;
        const newObj = new NovaObjednavka();
        newObj.klienti = this.klienti;
        newObj.turnusy = this.turnusy;
        newObj.dny = this.dny;
        newObj.slevy = this.slevy;
        newObj.eko = this.eko;
        newObj.nekompletni = this.nekompletni;
        newObj.castecneMenu = this.castecneMenu;
        newObj.webObjednavka = this.webObjednavka == null ? null : this.webObjednavka.id;
        this.props.objednavkaStore.orderTemplate = newObj;
        console.log("createOrder: store call");
        this.props.objednavkaStore.createNewOrderObject(newObj)
            .then((retVal: NewOrderResponse) => {
                console.log('createOrder: new order: ' + retVal.objednavka.id);
                this.props.objednavkaStore.objednavky.push(retVal.objednavka);
                this.props.objednavkaStore.removeWebObjednavkaFromLocalStore(newObj.webObjednavka);
                retVal.turnusy.forEach(trns => {
                    this.props.turnusStore.addTurnus(trns);
                });
                console.log('createOrder: route: ' + whereTo);
                if(whereTo === 'invoice') {
                    this.props.history.push(`/orders/${retVal.objednavka.id}/invoicingFromNew`)
                } else if(whereTo === 'paymentDetails') {
                    this.props.history.push(`/paymentDetails/${retVal.objednavka.id}`)
                } else if(whereTo === 'orderDetails') {
                    this.props.history.push(`/orders/${retVal.objednavka.id}`)
                }
            });
    }    
    
    @action
    private handleSlevaChange = clientId => event => {
        this.slevy.set(clientId, event.target.value);
        this.slevySet.set(clientId, true);
    }  
    
    @action
    private handleEkoChange = clientId => event => {
        this.eko.set(clientId, event.target.checked);
        this.ekoSet.set(clientId, true);
    }
    
    @action
    private handleNekompletniChange = clientId => event => {
        this.nekompletni.set(clientId, event.target.checked);
    }
    
    @action
    private handleCastecneMenuChange = clientId => event => {
        this.castecneMenu.set(clientId, event.target.checked);
        this.castecneMenuSet.set(clientId, true);
    }

    // Manipulace se dny

    private addDen = (den: Den) => {
        this.dny.get(den.idKlient).push(den);
    }

    private getDen(klientID: number, date: Date) {
        return this.dny.get(klientID).find((value: Den) => moment(value.datum).isSame(date, 'day'));
    }

    private removeDen(den: Den) {
        const index = this.dny.get(den.idKlient).findIndex(a => a === den);
        this.dny.get(den.idKlient).splice(index, 1);
    }

    private isDenSet(klientID: number, date: Date) {
        return !isUndefined(this.dny.get(klientID).find((value: Den) => moment(value.datum).isSame(date, 'day')));
    }

    private isTurnusActive(klientID: number, date: Date) {
        let retVal = false;
        this.turnusy.get(klientID).forEach((trns: Turnus) => {
            const odMoment = moment(trns.od);
            const doMoment = moment(trns.do);
            const toCheckMoment = moment(date);
            if(toCheckMoment.isBetween(odMoment, doMoment, 'day', '[]')) {
                retVal = true;
            }
        });
        return retVal;
    }

    private getActiveTurnus(klientID: number, date: Date): Turnus {
        return this.turnusy.get(klientID).find((trns: Turnus) => {
            const odMoment = moment(trns.od);
            const doMoment = moment(trns.do);
            const toCheckMoment = moment(date);
            if(toCheckMoment.isBetween(odMoment, doMoment, 'day', '[]')) {
                return true;
            }
            return false;
        });
    }

    // Kalendar na odhlasky

    @observable private triggerDate = moment();
    @observable private typDne: string = 'odhlaseny';
    @observable private zmenaProgram: number = this.props.ciselnikyStore.getLatestValidProgramByValue(5000).id;
    @observable private zmenaPlny: boolean = true;
    @observable private zmenaMenuSnidane: boolean = false;
    @observable private zmenaMenuSvacina1: boolean = false;
    @observable private zmenaMenuObed: boolean = false;
    @observable private zmenaMenuSvacina2: boolean = false;
    @observable private zmenaMenuVecere: boolean = false;

    @action
    private handleCalendarDayChangeDispatch = (klientID: number) => date => {
        this.handleCalendarDayChange(klientID)(date);
    }

    private handleCalendarDayChange = (klientID: number) => date => {
        this.triggerDate = moment(date);
        const den = new Den();
        den.datum = moment(date).toDate();

        // Odhlasku lze provest jen v ramci zadaneho turnusu
        // Nahradu lze zadat na kterykoliv den
        if(!this.isTurnusActive(klientID, den.datum) && this.typDne === 'odhlaseny') {
            return;
        }

        if(this.isDenSet(klientID, den.datum)) {
            const denToDelete = this.getDen(klientID, den.datum);
            this.removeDen(denToDelete);
        } else {
            if(this.typDne === 'zmena') {
                den.program = this.zmenaProgram;
                den.rozsah = [];
                if(this.zmenaPlny) {
                    den.rozsah.push('plny');
                } else {
                    if(this.zmenaMenuSnidane) {
                        den.rozsah.push('snidane');
                    }
                    if(this.zmenaMenuSvacina1) {
                        den.rozsah.push('svacina1');
                    }
                    if(this.zmenaMenuObed) {
                        den.rozsah.push('obed');
                    }
                    if(this.zmenaMenuSvacina2) {
                        den.rozsah.push('svacina2');
                    }
                    if(this.zmenaMenuVecere) {
                        den.rozsah.push('vecere');
                    }
                }
            }
            if(this.typDne === 'odhlaseny') {
                // Odhlasku lze provest jen v ramci zadaneho turnusu
                if(!this.isTurnusActive(klientID, den.datum)) {
                    return;
                }
            }
            den.idKlient = klientID;
            den.typ = this.typDne;
            this.addDen(den);
        }
    }

    private renderDay = (klientID: number) => (date, selectedDate, dayInCurrentMonth) => {
        const dateOrig = moment(date);
        const selectedDateOrig = moment(selectedDate);

        const startOfWeekDate = moment(selectedDate).startOf('week');
        const endOfWeekDate = moment(selectedDate).endOf('week');

        const start = dateOrig.isSame(startOfWeekDate, 'day');
        const end = dateOrig.isSame(endOfWeekDate, 'day');
        const between = dateOrig.isBetween(startOfWeekDate, endOfWeekDate);

        const classes = [];
        const classesDay = [this.props.classes.day];

        const isSet = this.isDenSet(klientID, date);

        if(isSet) {
            const den = this.getDen(klientID, date);
            if(den.typ === 'odhlaseny') {
                classes.push(this.props.classes.highlight);
            } else if(den.typ === 'nahrada') {
                classes.push(this.props.classes.highlightNahrada);
            } else if(den.typ === 'zmena') {
                classes.push(this.props.classes.highlightZmena);
            }
            classes.push(this.props.classes.fullHighlight);
        }

        if(!dayInCurrentMonth) {
            classesDay.push(this.props.classes.nonCurrentMonthDay);
        }

        let classesString:string = '';
        let classesDayString:string = '';

        classes.forEach(element => {
            classesString += element + ' ';
        });

        classesDay.forEach(element => {
            classesDayString += element + ' ';
        });

        return (
            <div className={classesString}>
                <IconButton className={classesDayString}>
                    <span> {dateOrig.format("D")} </span>
                </IconButton>
            </div>
        );
    }

    public render() {
        return (
                <div>
                    <Drawer open={this.isDrawerOpened} onClose={this.drawerMenuClick}>
                        <NavigationDrawerItems />
                    </Drawer>
                    <Grid container spacing={8}>
                        <Grid item xs={12}>
                            {this.isProgressBarOpened ? <LinearProgress variant="query" color="secondary" /> : ""}
                            <AppBar position="static" >
                                <Toolbar>
                                    <IconButton color="inherit" aria-label="Menu" onClick={this.drawerMenuClick}>
                                        <MenuIcon />
                                    </IconButton>
                                    <Typography variant="h6" color="inherit" style={{ flexGrow: 1 }}>
                                        Nová objednávka
                                    </Typography>
                                    <Tooltip title="Přidat klienta" aria-label="Přidat klienta">
                                        <IconButton color="inherit" aria-label="Přidat klienta" onClick={this.addClient}>
                                            <AddIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Button onClick={this.createOrder('orderDetails')} color="inherit">
                                        Založit
                                    </Button>
                                    {this.props.authStore.hasGUIResource('create-invoice') ?
                                        <Button onClick={this.createOrder('invoice')} color="inherit">
                                            Na fakturaci
                                        </Button> : ''}
                                    {this.props.authStore.hasGUIResource('send-payment-details') ?
                                        <Button onClick={this.createOrder('paymentDetails')} color="inherit">
                                            Na platební údaje
                                        </Button> : ''}
                                </Toolbar>
                            </AppBar>
                        </Grid>
                        <Grid container xs={12} style={{ margin: 8 }}>

                            {this.webObjednavka != null && this.webObjednavka.poznamka != null && this.webObjednavka.poznamka.trim() !== "" ?
                            <ExpansionPanel style={{marginBottom: "10px"}}>
                                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography variant="h5" >Webová objednávka (poznámka)</Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <Typography style={{whiteSpace: "pre-line"}}>
                                        {this.webObjednavka.poznamka}
                                    </Typography>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                            :""}

                            {this.klienti.map(kl => (
                                <Grid item xs={12} style={{ marginBottom: 20 }}>
                                    <Paper square>
                                        <AppBar position="static" color="secondary" style={{ boxShadow: 'none', backgroundColor: '#8390c8'}}>
                                            <Toolbar variant="dense">
                                                <Typography variant="h6" color="inherit" style={{ marginRight: 20 }}>
                                                    Klient - {kl.jmeno + ' ' + kl.prijmeni}
                                                </Typography>
                                                <TextField id="new-order-sleva" select onChange={this.handleSlevaChange(kl.id)} 
                                                    value={this.slevy.get(kl.id)}>
                                                        <MenuItem value="-">Bez slevy</MenuItem>
                                                        {this.props.ciselnikyStore.slevy.map(sleva => (
                                                            <MenuItem value={sleva.id}>{sleva.name} ({sleva.value} Kč/den)</MenuItem>
                                                        ))}
                                                </TextField>
                                                <FormControlLabel style={{marginLeft: '15px'}}
                                                    control={<Checkbox checked={this.eko.get(kl.id)} onChange={this.handleEkoChange(kl.id)} />} 
                                                    label="EKO" />
                                                <FormControlLabel style={{marginLeft: '15px'}}
                                                    control={<Checkbox checked={this.nekompletni.get(kl.id)} onChange={this.handleNekompletniChange(kl.id)} />} 
                                                    label="Nekompletní turnus" />
                                                <FormControlLabel style={{marginLeft: '15px', flexGrow: 1}}
                                                    control={<Checkbox checked={this.castecneMenu.get(kl.id)} onChange={this.handleCastecneMenuChange(kl.id)} />} 
                                                    label="Částečné menu" />
                                                <Tooltip title="Přidat turnus" aria-label="Přidat turnus">
                                                    <IconButton color="inherit" aria-label="Přidat turnus" onClick={this.addTurnus(kl)}>
                                                        <AddIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </Toolbar>
                                        </AppBar>
                                        <Grid container xs={12} style={{ marginBottom: 20, paddingBottom: 10 }}>
                                            
                                            <Grid item xs={6} spacing={8} style={{ marginTop: 10, paddingLeft: 10, paddingRight: 10 }}>
                                                <Typography variant="h6" color="inherit" style={{ flexGrow: 1 }}>
                                                    Turnusy
                                                </Typography>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>Od - do</TableCell>
                                                            <TableCell>Program</TableCell>
                                                            <TableCell />
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {this.turnusy.get(kl.id).map(turnus => (
                                                            <TableRow hover key={turnus.id} onClick={this.handleTurnusRowClick(turnus)}>
                                                                <TableCell>{turnus.od.toLocaleDateString() + " - " + turnus.do.toLocaleDateString()}</TableCell>
                                                                <TableCell>{this.props.ciselnikyStore.getProgramByID(turnus.program).value} kJ</TableCell>
                                                                <TableCell>
                                                                    <IconButton color="inherit" aria-label="Delete" onClick={this.handleTurnusDeleteClick(turnus)}>
                                                                        <DeleteIcon />
                                                                    </IconButton>
                                                                </TableCell>
                                                            </TableRow>
                                                            ))
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </Grid>
                                            <Grid item xs={6} spacing={8} style={{ marginTop: 10, paddingLeft: 10, paddingRight: 10 }}>
                                                {/* <Typography variant="h6" color="inherit" style={{ flexGrow: 1 }}>
                                                    Dny
                                                </Typography> */}
                                                <div style={{display: 'flex', justifyContent: 'flex-start', flexDirection: 'row'}}>
                                                    <Paper style={{ overflow: "hidden" }}>
                                                        <Calendar   renderDay={this.renderDay(kl.id)} 
                                                                    date={this.triggerDate} 
                                                                    onChange={this.handleCalendarDayChangeDispatch(kl.id)} 
                                                                    minDate={moment("2020-01-01")} 
                                                                    maxDate={moment("2030-12-25")} />
                                                    </Paper>
                                                    <div style={{marginLeft: 10}}>
                                                    <RadioGroup value={this.typDne} style={{flexDirection: 'column'}} onChange={this.handleChange('typDne')}>
                                                        <FormControlLabel value="odhlaseny" control={<Radio />} label={"Odhlášení"} />
                                                        <FormControlLabel value="nahrada" control={<Radio />} label={"Náhrada"} />
                                                        <FormControlLabel value="zmena" control={<Radio />} label={"Změna"} />
                                                    </RadioGroup>
                                                    {this.typDne!=='zmena'?'':(
                                                    <div style={{display: 'flex', justifyContent: 'flex-start', flexDirection: 'column'}}>
                                                        <div>
                                                            <TextField style={{marginRight: '15px'}} label="Program" id="new-turnus-program" select onChange={this.handleChange('zmenaProgram')} 
                                                                value={this.zmenaProgram}>
                                                                    {this.props.ciselnikyStore.getAllValidPrograms().map(prg => (
                                                                        <MenuItem value={prg.id}>{prg.value} kJ ({prg.price} Kč/den)</MenuItem>
                                                                    ))}
                                                            </TextField>
                                                            Plné menu: <Switch checked={this.zmenaPlny} onChange={this.handleCheckedChange('zmenaPlny', true, false)} />
                                                        </div>
                                                        {this.zmenaPlny?'':(
                                                        <div>
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox checked={this.zmenaMenuSnidane} onChange={this.handleCheckedChange('zmenaMenuSnidane', true, false)} />
                                                                }
                                                                label="Snídaně"
                                                                />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox checked={this.zmenaMenuSvacina1} onChange={this.handleCheckedChange('zmenaMenuSvacina1', true, false)} />
                                                                }
                                                                label="Svačina 1"
                                                                />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox checked={this.zmenaMenuObed} onChange={this.handleCheckedChange('zmenaMenuObed', true, false)} />
                                                                }
                                                                label="Oběd"
                                                                />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox checked={this.zmenaMenuSvacina2} onChange={this.handleCheckedChange('zmenaMenuSvacina2', true, false)} />
                                                                }
                                                                label="Svačina 2"
                                                                />
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox checked={this.zmenaMenuVecere} onChange={this.handleCheckedChange('zmenaMenuVecere', true, false)} />
                                                                }
                                                                label="Večeře"
                                                                />
                                                        </div>)}
                                                    </div>)}
                                                    </div>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                    <Dialog
                        open={this.isDeleteDialogOpened}
                        onClose={this.handleDialClose('isDeleteDialogOpened')}
                        aria-labelledby="delete-confirm-dialog">
                        <DialogTitle id="delete-confirm-dialog">Smazat</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Opravdu smazat?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleDialClose('isDeleteDialogOpened')} color="primary">
                                Storno
                            </Button>
                            <Button onClick={this.handleDeleteDialogOK} color="primary">
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <ClientSelectionDialog 
                        open={this.isClientSelectDialogOpen} 
                        onClose={this.handleDialClose('isClientSelectDialogOpen')} 
                        onSelect={this.clientSelected}
                        title="Přidat klienta" />
                    <TurnusNewDialog 
                        open={this.isNewTurnusDialogOpen} 
                        onClose={this.handleDialClose('isNewTurnusDialogOpen')} 
                        onAdd={this.turnusAdded} />
                    <TurnusEditDialog 
                        open={this.isEditTurnusDialogOpen} 
                        onClose={this.handleDialClose('isEditTurnusDialogOpen')} 
                        onChange={this.turnusChanged}
                        turnus={this.turnusToEdit} />
                </div>
        )
    }
}

export default  withRouter(withStyles(styles)(OrderNew));


// WEBPACK FOOTER //
// ./src/components/OrderNew.tsx